export default __webpack_public_path__ + "images/bt-eed19cbfd0dc809d6886614fe43413d5.svg";